var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBooklead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2115_73574",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V14H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2115_73574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 6.21924V10.6042C11.8125 11.0403 11.6312 11.4076 11.2687 11.7062C10.9316 11.9837 10.5296 12.1225 10.0625 12.1225H3.9375C3.47043 12.1225 3.06837 11.9837 2.73132 11.7062C2.36877 11.4076 2.1875 11.0403 2.1875 10.6042V3.39912C2.1875 2.96302 2.36877 2.59571 2.73132 2.29717C3.06837 2.01963 3.47043 1.88086 3.9375 1.88086H6.6377C6.80208 1.88088 6.96073 1.90697 7.11367 1.95914C7.27107 2.01282 7.41127 2.0903 7.53427 2.19157L11.3969 5.37219C11.5264 5.47886 11.6272 5.6038 11.6992 5.74699C11.7747 5.89705 11.8125 6.05452 11.8125 6.21924ZM10.9375 6.21931C10.9375 6.193 10.9308 6.16663 10.9176 6.14021C10.9008 6.10692 10.8752 6.07607 10.8407 6.04766L6.97814 2.8671C6.9371 2.83331 6.88811 2.8067 6.83119 2.78728C6.76979 2.76634 6.7053 2.75587 6.6377 2.75586H3.9375C3.6797 2.75586 3.46304 2.82812 3.28753 2.97264C3.13751 3.09617 3.0625 3.23833 3.0625 3.39912V10.6042C3.0625 10.765 3.13751 10.9072 3.28753 11.0307C3.46304 11.1752 3.6797 11.2475 3.9375 11.2475H10.0625C10.3203 11.2475 10.537 11.1752 10.7125 11.0307C10.8625 10.9072 10.9375 10.765 10.9375 10.6042V6.21931Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2.06104C6.75838 2.06104 6.5625 2.25691 6.5625 2.49854V5.20044C6.5625 5.53706 6.70106 5.81946 6.97818 6.04765C7.22981 6.25485 7.52875 6.35845 7.875 6.35845H11.1562C11.3979 6.35845 11.5937 6.16257 11.5937 5.92095C11.5937 5.67933 11.3979 5.48345 11.1562 5.48345H7.875C7.738 5.48345 7.62447 5.44636 7.53438 5.37218C7.46979 5.319 7.4375 5.26175 7.4375 5.20044V2.49854C7.4375 2.25691 7.24162 2.06104 7 2.06104ZM4.375 7.72222C4.375 7.96384 4.57088 8.15972 4.8125 8.15972H9.1875C9.42912 8.15972 9.625 7.96384 9.625 7.72222C9.625 7.48059 9.42912 7.28472 9.1875 7.28472H4.8125C4.57088 7.28472 4.375 7.48059 4.375 7.72222ZM4.375 9.52349C4.375 9.76511 4.57088 9.96099 4.8125 9.96099H9.1875C9.42912 9.96099 9.625 9.76511 9.625 9.52349C9.625 9.28186 9.42912 9.08599 9.1875 9.08599H4.8125C4.57088 9.08599 4.375 9.28186 4.375 9.52349Z",
    fill: "#565656"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooklead);
export default __webpack_public_path__ + "static/media/Booklead.b5e051ad8fd268abe94873f134da6229.svg";
export { ForwardRef as ReactComponent };